import Chart from 'chart.js/auto'
import { Box, Button, Divider, Drawer, Stack, Typography, useTheme } from '@mui/material'
import { AddSharp } from '@mui/icons-material'
import { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import ReactQuill from 'react-quill'
import DeleteIcon from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'
import { getModuleReport, FSHTMLText } from 'fs_design_system'
import SaveIcon from '@mui/icons-material/Save'
import { Report } from '../../shared/model/models'

import CompanyLogo from '../../assets/company/Logo.png'
import INESLogo from '../../assets/Logo_FAIR.png'
import DDGenderCoverPhoto from '../../assets/modulereport/dd-gender-cover.png'
import DDDisabilityCoverPhoto from '../../assets/modulereport/dd-disability-cover.png'
import DDOriginCoverPhoto from '../../assets/modulereport/dd-origin-cover.png'
import DDAgeGroupsCoverPhoto from '../../assets/modulereport/dd-age-groups-cover.png'
import ArrowRight from '../../assets/modulereport/arrow-right.png'

import PayCoverPhoto from '../../assets/modulereport/pay/cover.png'
import PayBackCoverPhoto from '../../assets/modulereport/pay/back-cover.png'
import PayPGGender from '../../assets/modulereport/pay/pg-gender.png'
import PayPGDisability from '../../assets/modulereport/pay/pg-disability.png'
import PayPGOrigin from '../../assets/modulereport/pay/pg-origin.png'
import PayPGAgeGroups from '../../assets/modulereport/pay/pg-age-groups.png'
import PayPGMain from '../../assets/modulereport/pay/pg-main.png'
import PayDDGreaterCompare from '../../assets/modulereport/pay/dd-greater-compare.png'
import PayDDLesserCompare from '../../assets/modulereport/pay/dd-lesser-compare.png'
import PayInequalPhoto from '../../assets/modulereport/pay/inequal.png'
import PayDDGenderInfoGraphicDE from '../../assets/modulereport/pay/dd-gender-infographic-de.png'
import PayDDGenderInfoGraphicEN from '../../assets/modulereport/pay/dd-gender-infographic-en.png'
import PayDDDisabilityInfoGraphicDE from '../../assets/modulereport/pay/dd-disability-infographic-de.png'
import PayDDDisabilityInfoGraphicEN from '../../assets/modulereport/pay/dd-disability-infographic-en.png'
import PayDDOriginInfoGraphicDE from '../../assets/modulereport/pay/dd-origin-infographic-de.png'
import PayDDOriginInfoGraphicEN from '../../assets/modulereport/pay/dd-origin-infographic-en.png'
import PayDDAgeGroupsInfoGraphicDE from '../../assets/modulereport/pay/dd-age-groups-infographic-de.png'
import PayDDAgeGroupsInfoGraphicEN from '../../assets/modulereport/pay/dd-age-groups-infographic-en.png'
import PayNoGapCauses from '../../assets/modulereport/pay/no-gap-causes.png'

import CareerCoverPhoto from '../../assets/modulereport/career/cover.png'
import CareerBackCoverPhoto from '../../assets/modulereport/career/back-cover.png'
import CareerPGGender from '../../assets/modulereport/career/pg-gender.png'
import CareerPGDisability from '../../assets/modulereport/career/pg-disability.png'
import CareerPGOrigin from '../../assets/modulereport/career/pg-origin.png'
import CareerPGAgeGroups from '../../assets/modulereport/career/pg-age-groups.png'
import CareerPGMain from '../../assets/modulereport/career/pg-main.png'
import CareerDDGreaterCompare from '../../assets/modulereport/career/dd-greater-compare.png'
import CareerDDLesserCompare from '../../assets/modulereport/career/dd-lesser-compare.png'
import CareerInequalPhoto from '../../assets/modulereport/career/inequal.png'
import CareerDDGenderInfoGraphicDE from '../../assets/modulereport/career/dd-gender-infographic-de.png'
import CareerDDGenderInfoGraphicEN from '../../assets/modulereport/career/dd-gender-infographic-en.png'
import CareerDDDisabilityInfoGraphicDE from '../../assets/modulereport/career/dd-disability-infographic-de.png'
import CareerDDDisabilityInfoGraphicEN from '../../assets/modulereport/career/dd-disability-infographic-en.png'
import CareerDDOriginInfoGraphicDE from '../../assets/modulereport/career/dd-origin-infographic-de.png'
import CareerDDOriginInfoGraphicEN from '../../assets/modulereport/career/dd-origin-infographic-en.png'
import CareerDDAgeGroupsInfoGraphicDE from '../../assets/modulereport/career/dd-age-groups-infographic-de.png'
import CareerDDAgeGroupsInfoGraphicEN from '../../assets/modulereport/career/dd-age-groups-infographic-en.png'
import CareerNoGapCauses from '../../assets/modulereport/career/no-gap-causes.png'

import WTCoverPhoto from '../../assets/modulereport/working_time/cover.png'
import WTBackCoverPhoto from '../../assets/modulereport/working_time/back-cover.png'
import WTPGGender from '../../assets/modulereport/working_time/pg-gender.png'
import WTPGDisability from '../../assets/modulereport/working_time/pg-disability.png'
import WTPGOrigin from '../../assets/modulereport/working_time/pg-origin.png'
import WTPGAgeGroups from '../../assets/modulereport/working_time/pg-age-groups.png'
import WTPGMain from '../../assets/modulereport/working_time/pg-main.png'
import WTDDGreaterCompare from '../../assets/modulereport/working_time/dd-greater-compare.png'
import WTDDLesserCompare from '../../assets/modulereport/working_time/dd-lesser-compare.png'
import WTInequalPhoto from '../../assets/modulereport/working_time/inequal.png'
import WTDDGenderInfoGraphicDE from '../../assets/modulereport/working_time/dd-gender-infographic-de.png'
import WTDDGenderInfoGraphicEN from '../../assets/modulereport/working_time/dd-gender-infographic-en.png'
import WTDDDisabilityInfoGraphicDE from '../../assets/modulereport/working_time/dd-disability-infographic-de.png'
import WTDDDisabilityInfoGraphicEN from '../../assets/modulereport/working_time/dd-disability-infographic-en.png'
import WTDDOriginInfoGraphicDE from '../../assets/modulereport/working_time/dd-origin-infographic-de.png'
import WTDDOriginInfoGraphicEN from '../../assets/modulereport/working_time/dd-origin-infographic-en.png'
import WTDDAgeGroupsInfoGraphicDE from '../../assets/modulereport/working_time/dd-age-groups-infographic-de.png'
import WTDDAgeGroupsInfoGraphicEN from '../../assets/modulereport/working_time/dd-age-groups-infographic-en.png'
import WTNoGapCauses from '../../assets/modulereport/working_time/no-gap-causes.png'

import TrainingCoverPhoto from '../../assets/modulereport/training/cover.png'
import TrainingBackCoverPhoto from '../../assets/modulereport/training/back-cover.png'
import TrainingPGGender from '../../assets/modulereport/training/pg-gender.png'
import TrainingPGDisability from '../../assets/modulereport/training/pg-disability.png'
import TrainingPGOrigin from '../../assets/modulereport/training/pg-origin.png'
import TrainingPGAgeGroups from '../../assets/modulereport/training/pg-age-groups.png'
import TrainingPGMain from '../../assets/modulereport/training/pg-main.png'
import TrainingDDGreaterCompare from '../../assets/modulereport/training/dd-greater-compare.png'
import TrainingDDLesserCompare from '../../assets/modulereport/training/dd-lesser-compare.png'
import TrainingInequalPhoto from '../../assets/modulereport/training/inequal.png'
import TrainingDDGenderInfoGraphicDE from '../../assets/modulereport/training/dd-gender-infographic-de.png'
import TrainingDDGenderInfoGraphicEN from '../../assets/modulereport/training/dd-gender-infographic-en.png'
import TrainingDDDisabilityInfoGraphicDE from '../../assets/modulereport/training/dd-disability-infographic-de.png'
import TrainingDDDisabilityInfoGraphicEN from '../../assets/modulereport/training/dd-disability-infographic-en.png'
import TrainingDDOriginInfoGraphicDE from '../../assets/modulereport/training/dd-origin-infographic-de.png'
import TrainingDDOriginInfoGraphicEN from '../../assets/modulereport/training/dd-origin-infographic-en.png'
import TrainingDDAgeGroupsInfoGraphicDE from '../../assets/modulereport/training/dd-age-groups-infographic-de.png'
import TrainingDDAgeGroupsInfoGraphicEN from '../../assets/modulereport/training/dd-age-groups-infographic-en.png'
import TrainingNoGapCauses from '../../assets/modulereport/training/no-gap-causes.png'

import { updateReport } from '../../store/actions'
import { useAppDispatch } from '../../store/hooks'
import { Module } from '../../shared/model'
import { fsColors } from '../../shared/constants'

const FAIRPayFull = ({
  data,
  pageNumber = 0,
  scale = 0.8,
  showEditSummary = false,
  setShowEditSummary,
  setIsDirtied,
  setIndexPages,
  setTotalPages,
  setCurrentPage,
}: {
  data: Report
  pageNumber?: number
  scale?: number
  showEditSummary: boolean
  setShowEditSummary: any
  setIsDirtied: any
  setIndexPages: any
  setTotalPages: any
  setCurrentPage?: any
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const canvas = document.createElement('canvas')
  canvas.width = 1200
  canvas.height = 900

  const getModuleImages = () => {
    switch (data.reportModule) {
      case Module.PAY:
        return {
          CoverPhoto: PayCoverPhoto,
          BackCoverPhoto: PayBackCoverPhoto,
          PGGender: PayPGGender,
          PGDisability: PayPGDisability,
          PGOrigin: PayPGOrigin,
          PGAgeGroups: PayPGAgeGroups,
          PGMain: PayPGMain,
          DDGreaterCompare: PayDDGreaterCompare,
          DDLesserCompare: PayDDLesserCompare,
          InequalPhoto: PayInequalPhoto,
          NoGapCauses: PayNoGapCauses,
          DDGenderInfoGraphic:
            data.locale === 'de' ? PayDDGenderInfoGraphicDE : PayDDGenderInfoGraphicEN,
          DDDisabilityInfoGraphic:
            data.locale === 'de' ? PayDDDisabilityInfoGraphicDE : PayDDDisabilityInfoGraphicEN,
          DDOriginInfoGraphic:
            data.locale === 'de' ? PayDDOriginInfoGraphicDE : PayDDOriginInfoGraphicEN,
          DDAgeGroupsInfoGraphic:
            data.locale === 'de' ? PayDDAgeGroupsInfoGraphicDE : PayDDAgeGroupsInfoGraphicEN,
        }
      case Module.CAREER:
        return {
          CoverPhoto: CareerCoverPhoto,
          BackCoverPhoto: CareerBackCoverPhoto,
          PGGender: CareerPGGender,
          PGDisability: CareerPGDisability,
          PGOrigin: CareerPGOrigin,
          PGAgeGroups: CareerPGAgeGroups,
          PGMain: CareerPGMain,
          DDGreaterCompare: CareerDDGreaterCompare,
          DDLesserCompare: CareerDDLesserCompare,
          InequalPhoto: CareerInequalPhoto,
          NoGapCauses: CareerNoGapCauses,
          DDGenderInfoGraphic:
            data.locale === 'de' ? CareerDDGenderInfoGraphicDE : CareerDDGenderInfoGraphicEN,
          DDDisabilityInfoGraphic:
            data.locale === 'de'
              ? CareerDDDisabilityInfoGraphicDE
              : CareerDDDisabilityInfoGraphicEN,
          DDOriginInfoGraphic:
            data.locale === 'de' ? CareerDDOriginInfoGraphicDE : CareerDDOriginInfoGraphicEN,
          DDAgeGroupsInfoGraphic:
            data.locale === 'de' ? CareerDDAgeGroupsInfoGraphicDE : CareerDDAgeGroupsInfoGraphicEN,
        }
      case Module.WORKING_TIME:
        return {
          CoverPhoto: WTCoverPhoto,
          BackCoverPhoto: WTBackCoverPhoto,
          PGGender: WTPGGender,
          PGDisability: WTPGDisability,
          PGOrigin: WTPGOrigin,
          PGAgeGroups: WTPGAgeGroups,
          PGMain: WTPGMain,
          DDGreaterCompare: WTDDGreaterCompare,
          DDLesserCompare: WTDDLesserCompare,
          InequalPhoto: WTInequalPhoto,
          NoGapCauses: WTNoGapCauses,
          DDGenderInfoGraphic:
            data.locale === 'de' ? WTDDGenderInfoGraphicDE : WTDDGenderInfoGraphicEN,
          DDDisabilityInfoGraphic:
            data.locale === 'de' ? WTDDDisabilityInfoGraphicDE : WTDDDisabilityInfoGraphicEN,
          DDOriginInfoGraphic:
            data.locale === 'de' ? WTDDOriginInfoGraphicDE : WTDDOriginInfoGraphicEN,
          DDAgeGroupsInfoGraphic:
            data.locale === 'de' ? WTDDAgeGroupsInfoGraphicDE : WTDDAgeGroupsInfoGraphicEN,
        }
      case Module.TRAINING:
        return {
          CoverPhoto: TrainingCoverPhoto,
          BackCoverPhoto: TrainingBackCoverPhoto,
          PGGender: TrainingPGGender,
          PGDisability: TrainingPGDisability,
          PGOrigin: TrainingPGOrigin,
          PGAgeGroups: TrainingPGAgeGroups,
          PGMain: TrainingPGMain,
          DDGreaterCompare: TrainingDDGreaterCompare,
          DDLesserCompare: TrainingDDLesserCompare,
          InequalPhoto: TrainingInequalPhoto,
          NoGapCauses: TrainingNoGapCauses,
          DDGenderInfoGraphic:
            data.locale === 'de' ? TrainingDDGenderInfoGraphicDE : TrainingDDGenderInfoGraphicEN,
          DDDisabilityInfoGraphic:
            data.locale === 'de'
              ? TrainingDDDisabilityInfoGraphicDE
              : TrainingDDDisabilityInfoGraphicEN,
          DDOriginInfoGraphic:
            data.locale === 'de' ? TrainingDDOriginInfoGraphicDE : TrainingDDOriginInfoGraphicEN,
          DDAgeGroupsInfoGraphic:
            data.locale === 'de'
              ? TrainingDDAgeGroupsInfoGraphicDE
              : TrainingDDAgeGroupsInfoGraphicEN,
        }
      default:
        return {
          CoverPhoto: PayCoverPhoto,
          BackCoverPhoto: PayBackCoverPhoto,
          PGGender: PayPGGender,
          PGDisability: PayPGDisability,
          PGOrigin: PayPGOrigin,
          PGAgeGroups: PayPGAgeGroups,
          PGMain: PayPGMain,
          DDGreaterCompare: PayDDGreaterCompare,
          DDLesserCompare: PayDDLesserCompare,
          InequalPhoto: PayInequalPhoto,
          NoGapCauses: PayNoGapCauses,
          DDGenderInfoGraphic:
            data.locale === 'de' ? PayDDGenderInfoGraphicDE : PayDDGenderInfoGraphicEN,
          DDDisabilityInfoGraphic:
            data.locale === 'de' ? PayDDDisabilityInfoGraphicDE : PayDDDisabilityInfoGraphicEN,
          DDOriginInfoGraphic:
            data.locale === 'de' ? PayDDOriginInfoGraphicDE : PayDDOriginInfoGraphicEN,
          DDAgeGroupsInfoGraphic:
            data.locale === 'de' ? PayDDAgeGroupsInfoGraphicDE : PayDDAgeGroupsInfoGraphicEN,
        }
    }
  }

  const images: any = {
    ...getModuleImages(),
    CompanyLogo,
    INESLogo,
    DDGenderCoverPhoto,
    DDDisabilityCoverPhoto,
    DDOriginCoverPhoto,
    DDAgeGroupsCoverPhoto,
    ArrowRight,
  }

  const {
    firstRunDate,
    moduleSummary,
    moduleDescription,
    contextVariantGaps,
    contextVariantsInfo,
    empiricalConceptsInfo,
    companySummary,
  } = data.reportData

  const [companyCurSummary, setCompanyCurSummary] = useState(companySummary)

  const getReportDivDims = () => {
    if (data.reportTheme.diversityDimensions) {
      let noOfIndexColumns = data.reportTheme.diversityDimensions.length
      if (data.reportTheme.diversityDimensions.includes('age_groups')) {
        noOfIndexColumns += 2
      }
      setIndexPages(Math.ceil(noOfIndexColumns / 2))
    }
    return data.reportTheme.diversityDimensions
  }

  const pages = getModuleReport({
    moduleSummary,
    modulesInfo: moduleDescription,
    contextVariantGaps,
    contextVariantsInfo,
    empiricalConceptsInfo,
    mode: 'browser',
    startDate: new Date(data.beginDate),
    endDate: new Date(data.endDate),
    canvas,
    reportModule: data.reportModule,
    reportDivDims: getReportDivDims(),
    scale,
    setCurrentPage,
    images,
    locale: data.locale,
    reportTheme: data.reportTheme,
    Chart,
    companySummary,
    firstRunDate: new Date(firstRunDate),
  })

  setTotalPages(pages.length)

  const curPage = pages[pageNumber - 1]

  const updateCompanySummary = async () => {
    await dispatch(
      updateReport({
        report: {
          ...data,
          reportData: {
            ...data.reportData,
            companySummary: companyCurSummary,
          },
        },
      }),
    )
    setIsDirtied(true)
    setShowEditSummary(false)
  }

  return (
    <>
      <div
        style={{
          width: `${1754 * scale}px`,
          height: `${1240 * scale}px`,
          margin: 'auto',
        }}
      >
        {curPage ? <curPage.comp {...curPage.args} /> : null}
      </div>
      <Drawer
        anchor="bottom"
        open={showEditSummary}
        onClose={() => setShowEditSummary(false)}
        ModalProps={{
          keepMounted: false,
        }}
        PaperProps={{
          sx: {
            height: 'calc(100% - 74px)',
            top: 74,
            width: '100%',
            paddingX: 4,
            elevation: 0,
            paddingY: 0,
          },
        }}
        variant="temporary"
        elevation={0}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          position="sticky"
          top={0}
          pt={6}
          pb={2}
          sx={{ backgroundColor: theme.palette.background.paper, zIndex: 5 }}
        >
          <Typography variant="h6" mr={4}>
            {t('edit.summary.title')}
          </Typography>
          <Box display="flex" pb={0.5} justifyContent="flex-end" sx={{ zIndex: 50 }}>
            <Button endIcon={<SaveIcon />} variant="contained" onClick={updateCompanySummary}>
              {t('edit.summary.save')}
            </Button>
            <Button
              variant="outlined"
              sx={{
                ml: 2,
              }}
              endIcon={<CloseIcon />}
              onClick={() => {
                setCompanyCurSummary(companySummary)
                setShowEditSummary(false)
              }}
            >
              {t('cancel')}
            </Button>
          </Box>
        </Stack>
        <Box
          className="fullscreen-editor"
          px={4}
          pt={2}
          pb={12}
          borderRadius={2}
          sx={{ backgroundColor: theme.palette.grey['50'] }}
        >
          {companyCurSummary.summary.map((section: any, index: number) =>
            section.isEditable ? (
              <>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    mr: 1,
                    position: 'absolute',
                    right: '62px',
                    marginTop: '22px',
                  }}
                  endIcon={<DeleteIcon />}
                  onClick={() =>
                    setCompanyCurSummary({
                      ...companyCurSummary,
                      summary: companyCurSummary.summary.filter((_: any, i: number) => i !== index),
                    })
                  }
                >
                  {t('edit.summary.remove')}
                </Button>
                <ReactQuill
                  style={{ marginTop: 16 }}
                  theme="snow"
                  key={`section_extra_${index}`}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ['bold', 'underline', 'strike'],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      [{ color: [] }, { background: [] }],
                    ],
                    clipboard: {
                      matchVisual: false,
                    },
                  }}
                  placeholder={t('edit.summary.placeholder')}
                  value={section.content.join('')}
                  onChange={(value) => {
                    const doc = new DOMParser().parseFromString(value, 'text/html')
                    // @ts-ignore
                    const arr = [...doc.body.children].map((child) => child.outerHTML)
                    setCompanyCurSummary({
                      ...companyCurSummary,
                      summary: [
                        ...companyCurSummary.summary.slice(0, index),
                        {
                          ...companyCurSummary.summary[index],
                          content: arr,
                        },
                        ...companyCurSummary.summary.slice(index + 1),
                      ],
                    })
                  }}
                />
              </>
            ) : (
              <>
                <FSHTMLText mode="browser" key={`section_content_${index}`}>
                  {section.content.join('')}
                </FSHTMLText>
                {(!companyCurSummary.summary[index + 1] ||
                  (companyCurSummary.summary[index + 1] &&
                    !companyCurSummary.summary[index + 1].isEditable)) && (
                  <Divider sx={{ mt: 2 }}>
                    <Button
                      size="small"
                      onClick={() =>
                        setCompanyCurSummary({
                          ...companyCurSummary,
                          summary: [
                            ...companyCurSummary.summary.slice(0, index + 1),
                            { content: [], isEditable: true },
                            ...companyCurSummary.summary.slice(index + 1),
                          ],
                        })
                      }
                      sx={{
                        textTransform: 'capitalize',
                        color: fsColors.fsGray.primary,
                        backgroundColor: fsColors.fsDarkBlue.colors[2],
                        ':hover': {
                          backgroundColor: fsColors.fsDarkBlue.colors[2],
                        },
                      }}
                      endIcon={<AddSharp />}
                    >
                      {t('edit.summary.add')}
                    </Button>
                  </Divider>
                )}
              </>
            ),
          )}
        </Box>
      </Drawer>
    </>
  )
}

export default FAIRPayFull
